
















































































































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import DxChart, {
  DxSeries,
  DxLegend,
  DxTooltip,
  DxLabel,
  DxValueAxis,
} from "devextreme-vue/chart";
import pedidoModule from "@/store/modules/pedido-module";
import { pedido } from "@/shared/dtos/pedido";
import dashboardstatsModule from "@/store/modules/dashboardstats-module";
import { DashboardStatsDto } from "@/shared/dtos/dashboard-stats.dto";
import InformeVentas from "@/views/home/InformeVentas.vue";
import ocultarcamposModule from "@/store/modules/ocultarcampos-module";
import KpiCard from "@/views/home/KpiCard.vue";
import { RouterNames } from "@/router/routernames";

@Component({
  components: { InformeVentas, DxChart, DxSeries, DxLegend, DxTooltip, DxLabel, DxValueAxis, KpiCard },
})
export default class DashGeneral extends Vue {
  selectedPedidos: number[] = [];
  pedidos: pedido[] = [];
  fechaDesde: string | null = null;
  fechaHasta: string | null = null;
  menu1: boolean = false;
  menu2: boolean = false;
  cargando: boolean = true;
  private _initializando: boolean = true;
  showIngresos: boolean = true;
  showCoste: boolean = true;
  showGanancia: boolean = true;
  showRoi: boolean = true;
  showTicket: boolean = false;
  presetActivo: string = "todo";

  readonly pedidoHeaders = [
    { text: "Referencia",    value: "referencia",          sortable: true  },
    { text: "Coste pagado",  value: "costePedido",         sortable: true, align: "right" },
    { text: "Total uds",     value: "totalUnidades",       sortable: true, align: "right" },
    { text: "Vendidas",      value: "unidadesVendidas",    sortable: true, align: "right" },
    { text: "Restantes",     value: "unidadesRestantes",   sortable: true, align: "right" },
    { text: "Ingresos",      value: "ingresos",            sortable: true, align: "right" },
    { text: "Coste vendido", value: "costeVendido",        sortable: true, align: "right" },
    { text: "Coste restante",value: "costeRestante",       sortable: true, align: "right" },
    { text: "Ganancia",      value: "gananciaBruta",       sortable: true, align: "right" },
    { text: "ROI",           value: "roiPorcentaje",       sortable: true, align: "right" },
    { text: "% Liquidado",   value: "porcentajeLiquidado", sortable: true, align: "center" },
  ];

  get stats(): DashboardStatsDto {
    return dashboardstatsModule.stats;
  }

  get evaluacionNegocio() {
    const roi = this.stats.roiPorcentaje || 0;
    const ingresos = this.stats.totalIngresos || 0;
    const ganancia = this.stats.gananciaBruta || 0;
    const mermas = this.stats.mermaRoto || 0;
    
    if (ingresos === 0) {
      return { 
        texto: "Aún no hay suficientes ventas en este período para evaluar el estado del negocio. ¡Es hora de darle caña a las ventas!",
        color: "grey",
        icono: "mdi-information-outline"
      };
    }

    if (roi > 0 && ganancia < 1000) {
      return { 
        texto: `Margen positivo (ROI ${roi.toFixed(1)}%), pero el volumen de beneficio es muy bajo (${ganancia.toFixed(2)} €). Aunque el porcentaje parezca bueno, con estos números absolutos el negocio no es sostenible a largo plazo. Necesitas escalar: compra más inventario y aumenta el ritmo de ventas.`,
        color: "warning",
        icono: "mdi-scale-balance"
      };
    } else if (roi > 40) {
      return { 
        texto: `¡Excelente rendimiento! El negocio va de maravilla. Tienes un ROI del ${roi.toFixed(1)}% y un beneficio de ${ganancia.toFixed(2)} €, lo que significa que estás obteniendo una gran rentabilidad con buen volumen.`,
        color: "success",
        icono: "mdi-rocket-launch"
      };
    } else if (roi >= 20) {
      return { 
        texto: `Buen progreso. El negocio es sólido con un beneficio de ${ganancia.toFixed(2)} € (ROI del ${roi.toFixed(1)}%). Estás generando ingresos constantes, pero siempre hay margen para optimizar precios o reducir mermas.`,
        color: "info",
        icono: "mdi-trending-up"
      };
    } else if (roi > 0) {
      return { 
        texto: `Cuidado, estás generando ${ganancia.toFixed(2)} € pero el margen es muy ajustado (ROI del ${roi.toFixed(1)}%). Con este nivel de rentabilidad asumes mucho riesgo. Revisa los costes de los próximos lotes o sube los precios.`,
        color: "warning",
        icono: "mdi-alert"
      };
    } else {
      return { 
        texto: `Atención crítica: El negocio está en pérdidas en este período (${ganancia.toFixed(2)} €, ROI ${roi.toFixed(1)}%). Estás perdiendo dinero. Toca paralizar gastos innecesarios, liquidar mermas (${mermas} uds) y revisar drásticamente las compras.`,
        color: "error",
        icono: "mdi-alert-octagon"
      };
    }
  }

  get ocultarEfectivo(): boolean {
    return ocultarcamposModule.Ocultar_tarjeta_efectivo;
  }

  get totalPedidos() {
    const rows = this.stats.resumenPorPedido;
    if (!rows || rows.length === 0) {
      return { costePedido: 0, totalUnidades: 0, unidadesVendidas: 0, unidadesRestantes: 0, ingresos: 0, costeVendido: 0, costeRestante: 0, gananciaBruta: 0, roiPorcentaje: 0 };
    }
    const sum = (fn: (r: any) => number) => rows.reduce((a: number, r: any) => a + fn(r), 0);
    const costeVend = sum(r => r.costeVendido);
    const gan = sum(r => r.gananciaBruta);
    return {
      costePedido:       Math.round(sum(r => r.costePedido)       * 100) / 100,
      totalUnidades:     sum(r => r.totalUnidades),
      unidadesVendidas:  sum(r => r.unidadesVendidas),
      unidadesRestantes: sum(r => r.unidadesRestantes),
      ingresos:          Math.round(sum(r => r.ingresos)          * 100) / 100,
      costeVendido:      Math.round(costeVend                     * 100) / 100,
      costeRestante:     Math.round(sum(r => r.costeRestante)     * 100) / 100,
      gananciaBruta:     Math.round(gan                           * 100) / 100,
      roiPorcentaje:     costeVend > 0 ? Math.round((gan / costeVend) * 10000) / 100 : 0,
    };
  }

  fmt(n: number): string {
    return isNaN(n) ? "0.00" : n.toFixed(2);
  }

  /** Calcula porcentaje de parte sobre total, devuelve 0 si total es 0 */
  pct(parte: number, total: number): number {
    if (!total || total <= 0) return 0;
    return Math.min(100, Math.round((parte / total) * 100));
  }

  aplicarPreset(preset: string) {
    const hoy = new Date();
    const iso = (d: Date) => d.toISOString().substring(0, 10);
    this.presetActivo = preset;
    if (preset === "todo") {
      if (!this.fechaDesde && !this.fechaHasta) {
        this.cargar(); // watchers no disparan si ya eran null
      } else {
        this.fechaDesde = null;
        this.fechaHasta = null;
      }
    } else if (preset === "hoy") {
      this.fechaDesde = iso(hoy);
      this.fechaHasta = iso(hoy);
    } else if (preset === "7d") {
      const d = new Date(hoy); d.setDate(hoy.getDate() - 7);
      this.fechaDesde = iso(d); this.fechaHasta = iso(hoy);
    } else if (preset === "30d") {
      const d = new Date(hoy); d.setDate(hoy.getDate() - 30);
      this.fechaDesde = iso(d); this.fechaHasta = iso(hoy);
    } else if (preset === "mes") {
      const d = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
      this.fechaDesde = iso(d); this.fechaHasta = iso(hoy);
    } else if (preset === "año") {
      const d = new Date(hoy.getFullYear(), 0, 1);
      this.fechaDesde = iso(d); this.fechaHasta = iso(hoy);
    }
  }

  async mounted() {
    this.cargando = true;
    // Pedidos y stats en paralelo: tiempo total = max(T_pedidos, T_stats) en vez de suma
    await Promise.all([
      pedidoModule.getpedidos(),
      dashboardstatsModule.getStats({
        incluirEfectivo: !ocultarcamposModule.Ocultar_tarjeta_efectivo,
      }),
    ]);
    // Pre-seleccionar todos los pedidos sin que el watcher relance cargar()
    this.pedidos = pedidoModule.pedidos.slice();
    this._initializando = true;
    this.selectedPedidos = this.pedidos.map((p) => p.id);
    this._initializando = false;
    this.cargando = false;
  }

  @Watch("selectedPedidos")
  onPedidosChange() { if (!this._initializando) { this.cargar(); } }

  @Watch("fechaDesde")
  onDesdeChange() { this.cargar(); }

  @Watch("fechaHasta")
  onHastaChange() { this.cargar(); }

  @Watch("ocultarEfectivo")
  onEfectivoChange() { this.cargar(); }

  async cargar() {
    this.cargando = true;
    const params: any = {
      incluirEfectivo: !ocultarcamposModule.Ocultar_tarjeta_efectivo,
    };
    if (this.selectedPedidos.length > 0) {
      params.pedidos = this.selectedPedidos.join(",");
    }
    if (this.fechaDesde) { params.desde = this.fechaDesde; }
    if (this.fechaHasta) { params.hasta = this.fechaHasta; }
    await dashboardstatsModule.getStats(params);
    this.cargando = false;
  }

  tooltipTopVendido(arg: any) {
    const d = arg.point && arg.point.data;
    if (!d) { return { text: "" }; }
    return { text: d.descripcion + "\nASIN: " + d.asin + "\n" + d.unidades + " uds." };
  }

  irAVendidas() {
    this.$router.push({ name: RouterNames.stockhistorialventa, params: { id: "24" } }).catch(()=>{});
  }

  irAAnalisisStockTodos() {
    this.$router.push({
      name: "analisis_stock",
      query: { pedidos: this.selectedPedidos.join(",") }
    }).catch(()=>{});
  }

  irADevoluciones() {
    this.$router.push({ name: RouterNames.devolucioneslista }).catch(()=>{});
  }

  irAReservados() {
    this.$router.push({ name: RouterNames.reservaslista }).catch(()=>{});
  }

  irAPendienteCobro() {
    this.$router.push({ name: RouterNames.pdtelista }).catch(()=>{});
  }

  irAAnalisisPedido(item: any) {
    this.$router.push({
      name: "analisis_stock",
      query: { pedidos: item.pedidoId ? item.pedidoId.toString() : "" }
    }).catch(()=>{});
  }
}
